import { render, staticRenderFns } from "./ProductDetailBase.vue?vue&type=template&id=4bd1fc75&scoped=true"
import script from "./ProductDetailBase.vue?vue&type=script&lang=js"
export * from "./ProductDetailBase.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailBase.vue?vue&type=style&index=0&id=4bd1fc75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1fc75",
  null
  
)

export default component.exports